module.exports = __webpack_public_path__ + "static/lionsuitcase-e2486ff24338cafb1fb507be30429348.jpeg";